<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c9wBMe/tc-custom/9781504050296.jpg?1705807841426" alt="This image is the cover for the book I Am Mary Dunne"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Am Mary Dunne
      </h1>
      <p class="bookDescription body article font2">
        <b>A day in the life of a mad housewife in Manhattan: </b><b>“One of the truest and most awesome books I have ever read” (<i>The</i><i> Scotsman</i>).</b><br/>  <br/> She was born Mary Dunne. A New York actress in a stalled career, she’s previously been known as Maria and Martha. Married three times, she’s also been called Mrs. Phelan, Mrs. Bell, and currently, Mrs. Terence Lavery—wife of the esteemed playwright. No wonder Mary Dunne forgot her name this morning at the hairdresser. She has no idea who she is anymore. Or maybe she’s just crazy. She’s curious to find out.<br/>  <br/> Over the course of a single day, Mary tries to recall more than her name. But as memories of her past come trickling back—infuriating, illuminating, and grievous—she realizes there’s so much she’d prefer to forget. As she tries to escape what she calls “the dooms,” Mary must confront what she’s done with her life—deliberately, haplessly, or by default. If only she <i>were</i> going crazy; it would be so much easier to explain it all away.<br/>  <br/> Hailed by the <i>Globe and Mail</i> as a “feminist novel written before the wave of feminist novels began,” <i>I Am Mary Dunne</i> is “as complex and satisfying as anything Moore has yet done” (<i>The </i><i>Observer</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Moore
      </h2>
      
      <p class="authorDescription body article">Brian Moore (1921&ndash;1999) was born in Ireland and lived most of his adult life in Canada and the United States. He was the author of many novels, including <I>The Colour of Blood</I>, <I>Lies of Silence</I>, and<I> The Doctor&rsquo;s Wife</I>&mdash;all shortlisted for the Man Booker Prize&mdash;as well as <I>Catholics</I>, <I>The Statement</I>,<I> I Am Mary Dunne</I>, and <I>The Magician&rsquo;s Wif</I>e. <I>The Luck of Ginger Coffey</I> was awarded Canada&rsquo;s most prestigious book prize, the Governor General&rsquo;s Award for Fiction.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0b7e4c71